// extracted by mini-css-extract-plugin
export var divider = "_r4-0";
export var systemMessage = "_r4-1";